import { Status } from '@essent/common';
import { getCustomerClear } from '@essent/customer';
import type { Summary } from '@essent/extension-offer';
import {
  getSummary,
  getSummaryClear,
  getSummaryError,
  getSummarySuccess,
} from '@essent/extension-offer';
import type { CollectionState } from '@innogy/utils-state';
import {
  createInitialCollectionState,
  updateCollectionState,
} from '@innogy/utils-state';
import type { Action } from '@ngrx/store';
import { createReducer, on } from '@ngrx/store';

export type RetentionSummaryState = CollectionState<Summary>;

export const unknownValue = 'unknown';

export const initialState: RetentionSummaryState =
  createInitialCollectionState();

const _summaryReducer = createReducer(
  initialState,
  on(getSummary, (state, action) =>
    updateCollectionState(state, action, {
      status: Status.PENDING,
    })
  ),
  on(getSummarySuccess, (state, action) =>
    updateCollectionState(state, action, {
      status: Status.SUCCESS,
      entry: action.payload,
    })
  ),
  on(getSummaryError, (state, action) =>
    updateCollectionState(state, action, {
      status: Status.ERROR,
      error: action.payload,
    })
  ),
  on(getSummaryClear, getCustomerClear, (_) => initialState)
);

export function summaryReducer(
  state: RetentionSummaryState = initialState,
  action: Action
): RetentionSummaryState {
  return _summaryReducer(state, action);
}
